import { MenuItem, TextField, Typography } from "@mui/material";
import { RobotAgent, RobotConnectionState } from "../../panels/worldpanelparts/robot/RobotAgent";
import { useState, useEffect } from "react";
import { AgentEvents } from "../../panels/worldpanelparts/agents/BaseAgent";
import { FlexContainer } from "../../components/FlexContainer";
import { Camera, VideoCall, VideoCameraFront, VideoSettings } from "@mui/icons-material";
import { RobotButton } from "./RobotButton";
import { av } from "react-router/dist/development/routeModules-C3oqzPpI";

export function CameraToolbar({ agent }: { agent: RobotAgent }) {
  const [a, setA] = useState(agent);
  const [selectedCamera, setSelectedCamera] = useState(agent.selectedCamera);
  useEffect(() => {
    const listener = (dgram: Partial<RobotAgent>) => {
      setA({ ...agent } as any);
      setSelectedCamera(agent.selectedCamera || '');
    };
    agent.on(AgentEvents.StateChange, listener);
    return () => {
      agent.off(AgentEvents.StateChange, listener);
    };
  }, [agent]);

  const { connectionState, availableCameras } = a;

  return (
    <div style={{ display: 'inline-block', paddingLeft: 16  }}>
      <RobotButton 
        actionLabelLength={32}
        actions={availableCameras.length > 0 ? availableCameras.map(cam => ({
          name: cam,
          Icon: <Camera color='success' fontSize="large" />,
          onClick: () => {
            setSelectedCamera(cam);
            agent.controlChannel.sendRequest({ selectedCamera: cam });
          },
          active: selectedCamera === cam,
          disabled: connectionState !== RobotConnectionState.Connected
        })) : [{
          name: 'No cameras',
          Icon: <Camera color='disabled' fontSize="large" />,
          onClick: () => {},
          active: true,
          disabled: true
        }]}
      select id="camera-select-button" />
    </div>
  );
}